/** Redux Reducers. */
import { setMainFormData as setOimMainFormData } from '../shared/store/slices/oim-mainUpdateSlice';
import { setHblFormData as setOimHblFormData } from '../shared/store/slices/oim-hblUpdateSlice';
import { setContainerFormData as setOimContainerFormData } from '../shared/store/slices/oim-containerUpdateSlice';
import { setContainerAliasFormData } from '../shared/store/slices/oim-containerAliasUpdateSlice';
import { setPresetFormData as setOimPresetFormData } from '../shared/store/slices/oim-presetUpdateSlice';
import { setFormData as setOimStatusFormData } from '../shared/store/slices/oim-statusUpdateSlice';
import { setFormData as setOimRateFormData } from '../shared/store/slices/oim-rateUpdateSlice';
import { setFormData as setOimCommentFormData } from '../shared/store/slices/oim-commentUpdateSlice';
import { setFormData as setOimDisputeFormData } from '../shared/store/slices/oim-disputeUpdateSlice';
import { addMainForm as addOimMainForm } from '../shared/store/slices/oim-mainUpdateSlice';
import { addHBL as addOimHBL } from '../shared/store/slices/oim-hblUpdateSlice';
import { addContainer as addOimContainer } from '../shared/store/slices/oim-containerUpdateSlice';
import { addAlias as addOimAlias } from '../shared/store/slices/oim-containerAliasUpdateSlice';
import { addRate as addOimRate } from '../shared/store/slices/oim-rateUpdateSlice';
import { addDispute as addOimDispute } from '../shared/store/slices/oim-disputeUpdateSlice';
import { addComment as addOimComment } from '../shared/store/slices/oim-commentUpdateSlice';
import { addStatus as addOimStatus } from '../shared/store/slices/oim-statusUpdateSlice';

import { setMainFormData as setOexMainFormData } from '../shared/store/slices/oex-mainUpdateSlice';
import { setHblFormData as setOexHblFormData } from '../shared/store/slices/oex-hblUpdateSlice';
import { setContainerFormData as setOexContainerFormData } from '../shared/store/slices/oex-containerUpdateSlice';
import { setPresetFormData as setOexPresetFormData } from '../shared/store/slices/oex-presetUpdateSlice';
import { setFormData as setOexStatusFormData } from '../shared/store/slices/oex-statusUpdateSlice';
import { setFormData as setOexCommentFormData } from '../shared/store/slices/oex-commentUpdateSlice';
import { setFormData as setOexDisputeFormData } from '../shared/store/slices/oex-disputeUpdateSlice';
import { setFormData as setOexRateFormData } from '../shared/store/slices/oex-rateUpdateSlice';
import { addMainForm as addOexMainForm } from '../shared/store/slices/oex-mainUpdateSlice';
import { addHBL as addOexHBL } from '../shared/store/slices/oex-hblUpdateSlice';
import { addContainer as addOexContainer } from '../shared/store/slices/oex-containerUpdateSlice';
import { addRate as addOexRate } from '../shared/store/slices/oex-rateUpdateSlice';
import { addDispute as addOexDispute } from '../shared/store/slices/oex-disputeUpdateSlice';
import { addComment as addOexComment } from '../shared/store/slices/oex-commentUpdateSlice';
import { addStatus as addOexStatus } from '../shared/store/slices/oex-statusUpdateSlice';

import { setMainFormData as setAimMainFormData } from '../shared/store/slices/aim-mainUpdateSlice';
import { setHblFormData as setAimHblFormData } from '../shared/store/slices/aim-hblUpdateSlice';
import { setContainerFormData as setAimContainerFormData } from '../shared/store/slices/aim-containerUpdateSlice';
import { setPresetFormData as setAimPresetFormData } from '../shared/store/slices/aim-presetUpdateSlice';
import { setFormData as setAimStatusFormData } from '../shared/store/slices/aim-statusUpdateSlice';
import { setFormData as setAimCommentFormData } from '../shared/store/slices/aim-commentUpdateSlice';
import { setFormData as setAimDisputeFormData } from '../shared/store/slices/aim-disputeUpdateSlice';
import { setFormData as setAimRateFormData } from '../shared/store/slices/aim-rateUpdateSlice';
import { addMainForm as addAimMainForm } from '../shared/store/slices/aim-mainUpdateSlice';
import { addHBL as addAimHBL } from '../shared/store/slices/aim-hblUpdateSlice';
import { addContainer as addAimContainer } from '../shared/store/slices/aim-containerUpdateSlice';
import { addRate as addAimRate } from '../shared/store/slices/aim-rateUpdateSlice';
import { addDispute as addAimDispute } from '../shared/store/slices/aim-disputeUpdateSlice';
import { addComment as addAimComment } from '../shared/store/slices/aim-commentUpdateSlice';
import { addStatus as addAimStatus } from '../shared/store/slices/aim-statusUpdateSlice';

import { setMainFormData as setAexMainFormData } from '../shared/store/slices/aex-mainUpdateSlice';
import { setHblFormData as setAexHblFormData } from '../shared/store/slices/aex-hblUpdateSlice';
import { setContainerFormData as setAexContainerFormData } from '../shared/store/slices/aex-containerUpdateSlice';
import { setPresetFormData as setAexPresetFormData } from '../shared/store/slices/aex-presetUpdateSlice';
import { setFormData as setAexStatusFormData } from '../shared/store/slices/aex-statusUpdateSlice';
import { setFormData as setAexCommentFormData } from '../shared/store/slices/aex-commentUpdateSlice';
import { setFormData as setAexDisputeFormData } from '../shared/store/slices/aex-disputeUpdateSlice';
import { setFormData as setAexRateFormData } from '../shared/store/slices/aex-rateUpdateSlice';
import { addMainForm as addAexMainForm } from '../shared/store/slices/aex-mainUpdateSlice';
import { addHBL as addAexHBL } from '../shared/store/slices/aex-hblUpdateSlice';
import { addContainer as addAexContainer } from '../shared/store/slices/aex-containerUpdateSlice';
import { addRate as addAexRate } from '../shared/store/slices/aex-rateUpdateSlice';
import { addDispute as addAexDispute } from '../shared/store/slices/aex-disputeUpdateSlice';
import { addComment as addAexComment } from '../shared/store/slices/aex-commentUpdateSlice';
import { addStatus as addAexStatus } from '../shared/store/slices/aex-statusUpdateSlice';

import { setMainFormData as setTruckingMainFormData } from '../shared/store/slices/trucking-mainUpdateSlice';
import { setBolFormData as setTruckingHblFormData } from '../shared/store/slices/trucking-bolUpdateSlice';
import { setPresetFormData as setTruckingPresetFormData } from '../shared/store/slices/trucking-presetUpdateSlice';
import { setFormData as setTruckingStatusFormData } from '../shared/store/slices/trucking-statusUpdateSlice';
import { setFormData as setTruckingCommentFormData } from '../shared/store/slices/trucking-commentUpdateSlice';
import { setFormData as setTruckingDisputeFormData } from '../shared/store/slices/trucking-disputeUpdateSlice';
import { setFormData as setTruckingRateFormData } from '../shared/store/slices/trucking-rateUpdateSlice';
import { addMainForm as addTruckingMainForm } from '../shared/store/slices/trucking-mainUpdateSlice';
import { addBOL } from '../shared/store/slices/trucking-bolUpdateSlice';
import { addRate as addTruckingRate } from '../shared/store/slices/trucking-rateUpdateSlice';
import { addDispute as addTruckingDispute } from '../shared/store/slices/trucking-disputeUpdateSlice';
import { addComment as addTruckingComment } from '../shared/store/slices/trucking-commentUpdateSlice';
import { addStatus as addTruckingStatus } from '../shared/store/slices/trucking-statusUpdateSlice';

import { setFormData as setFilterViewFormData } from '../shared/store/slices/filterViewListSlice';

import { getColumns as getOimColumns } from 'features/shipments/components/TableDefinition/OceanImportMainDef';
import { getColumns as getOexColumns } from 'features/shipments/components/TableDefinition/OceanExportMainDef';
import { getColumns as getAimColumns } from 'features/shipments/components/TableDefinition/AirImportMainDef';
import { getColumns as getAexColumns } from 'features/shipments/components/TableDefinition/AirExportMainDef';
import { getColumns as getTruckingColumns } from 'features/shipments/components/TableDefinition/TruckingMainDef';

export const reducerList = {
    setFilterViewFormData,

    setOimMainFormData,
    setOimHblFormData,
    setOimContainerFormData,
    setContainerAliasFormData,
    setOimPresetFormData,
    setOimStatusFormData,
    setOimRateFormData,
    setOimCommentFormData,
    setOimDisputeFormData,
    addOimMainForm,
    addOimHBL,
    addOimContainer,
    addOimAlias,
    addOimRate,
    addOimDispute,
    addOimComment,
    addOimStatus,

    setOexMainFormData,
    setOexHblFormData,
    setOexContainerFormData,
    setOexPresetFormData,
    setOexStatusFormData,
    setOexCommentFormData,
    setOexDisputeFormData,
    setOexRateFormData,
    addOexMainForm,
    addOexHBL,
    addOexContainer,
    addOexRate,
    addOexDispute,
    addOexComment,
    addOexStatus,

    setAimMainFormData,
    setAimHblFormData,
    setAimContainerFormData,
    setAimPresetFormData,
    setAimStatusFormData,
    setAimCommentFormData,
    setAimDisputeFormData,
    setAimRateFormData,
    addAimMainForm,
    addAimHBL,
    addAimContainer,
    addAimRate,
    addAimDispute,
    addAimComment,
    addAimStatus,

    setAexMainFormData,
    setAexHblFormData,
    setAexContainerFormData,
    setAexPresetFormData,
    setAexStatusFormData,
    setAexCommentFormData,
    setAexDisputeFormData,
    setAexRateFormData,
    addAexMainForm,
    addAexHBL,
    addAexContainer,
    addAexRate,
    addAexDispute,
    addAexComment,
    addAexStatus,

    setTruckingMainFormData,
    setTruckingHblFormData,
    setTruckingPresetFormData,
    setTruckingStatusFormData,
    setTruckingCommentFormData,
    setTruckingDisputeFormData,
    setTruckingRateFormData,
    addTruckingMainForm,
    addBOL,
    addTruckingRate,
    addTruckingDispute,
    addTruckingComment,
    addTruckingStatus,
};

export const getColumnsByType = {
    0: getOimColumns,
    1: getOexColumns,
    2: getAimColumns,
    3: getAexColumns,
    4: getTruckingColumns,
};
